import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_ORDER](state, payload) {
    state.order = payload;
  },
  [MutationsType.SET_ORDERS](state, payload) {
    state.orders = payload;
  },
  [MutationsType.ADD_ORDER](state, payload) {
    if (!state.orders) state.orders = [];
    state.orders.unshift(payload);
  },
  [MutationsType.UPDATE_ORDER](state, payload) {
    state.order = { ...state.order, ...payload };

    if (!state.orders || !state.orders.length) return;

    const orderInd = state.orders.findIndex((o) => o.id === payload.id);
    if (orderInd >= 0) Vue.set(state.orders, orderInd, { ...state.orders[orderInd], ...payload });
  },
  [MutationsType.REMOVE_ORDER](state, payload) {
    if (!state.orders) return;

    let orderInd = state.orders.findIndex((o) => o.id === payload.id);
    if (orderInd >= 0) Vue.delete(state.orders, orderInd);
  },
  [MutationsType.UNSUBSCRIBE_GET_ORDER](state, payload) {
    state.unsubscribeOrder = payload;
  },
  [MutationsType.UNSUBSCRIBE_GET_ALL_ORDERS](state, payload) {
    state.unsubscribeAllOrders = payload;
  },
  [MutationsType.SET_CART](state, payload) {
    state.cart = payload;
  },
  [MutationsType.ADD_CART_PRODUCT](state, payload) {
    state.cart.push(payload);
  },
  [MutationsType.REMOVE_CART_PRODUCT](state, payload) {
    if (payload >= 0) Vue.delete(state.cart, payload);
  },
  [MutationsType.SET_CART_IGV](state, payload) {
    state.cartIGV = payload;
  },
};
